<template>
  <div style="background-repeat: no-repeat;background-color: #ffffff;">
    <v-app-bar app clipped-left :dark="theme">
      <v-app-bar-nav-icon
        @click="navDrawerPinned = !navDrawerPinned"
        v-if="$vuetify.breakpoint.xsOnly"
      ></v-app-bar-nav-icon>
      <!--
        v-if="$vuetify.breakpoint.xsOnly && $route.params.standalone"
      <v-btn icon @click="closeThisWindr()" v-if="!$route.params.standalone">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <h2
        v-if="!$route.params.standalone"
        class="second-word font uppercase text-center justify-center"
      >
        {{ category.title }}
      </h2>
       lazy-src="@/assets/logo.png"
      -->
      <v-spacer />
      <v-avatar tile v-if="aspect_ratio == 1">
        <v-img
          class="justify-center"
          height="54"
          contain
          :aspect-ratio="aspect_ratio"
          style="'position:relative;"
          :src="imgr"
        ></v-img>
      </v-avatar>
      <v-img
        v-else
        class="justify-center"
        
        height="54"
        width="108"
        contain
        :aspect-ratio="aspect_ratio"
        :src="imgr"
      ></v-img>
      <v-toolbar-title>
        <v-spacer />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--
      <v-btn icon @click.stop="dialog=true">
        <v-icon>mdi-qrcode</v-icon>
      </v-btn>-->
      <!--
      <v-btn
        v-if="!$route.params.standalone"
        icon
        dark
        @click="closeThisWindr()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      -->
    </v-app-bar>
    <!--
    <v-navigation-drawer
      app
      clipped
      flat
      dark
      :permanent="!$vuetify.breakpoint.xsOnly || navDrawerPinned"
      
      stateless
      :key="navDrawerPinned"
    >-->
    <v-navigation-drawer
      v-model="navDrawerPinned"
      :absolute="$vuetify.breakpoint.xsOnly"
      :temporary="$vuetify.breakpoint.xsOnly"
      :permanent="!$vuetify.breakpoint.xsOnly"
      app
      clipped
      dark
     >
    

      <v-list two-line subheader :dense="$vuetify.breakpoint.xsOnly">
        <div v-if="$route.params.standalone"><br><v-subheader  style="font:Roboto Condensed !important;font-size:14pt;color:#fff" class="text-wrap">
          {{ category.title | truncate(70, '...') }}
          <br>
        </v-subheader><br>
        </div>
        <div v-if="!$route.params.standalone"><v-subheader class="text-truncate">
           <a @click="closeThisWindr()"><span style="font:Roboto Condensed !important;font-size:13pt;color:#fff">  
        <v-icon>mdi-chevron-left</v-icon> Back to Knowledge Base</span></a>
           
        </v-subheader>
        </div>
        <hr>
        <div v-if="!$route.params.standalone"><br><v-subheader style="font:Roboto Condensed !important;font-size:14pt;color:#fff" class="">
          {{ category.title | truncate(70, '...') }}
        </v-subheader><br>
        </div>
        <v-list-item-group v-model="selectedContent"
        active-class="bg-active"
          color="primary"
        >
           
          <v-list-item
            v-for="(content, index) in category.content"
            :key="content.id"
            :value="content"
          >
            <v-list-item-icon v-if="!$vuetify.breakpoint.xs && content.type == 'quiz'">
              <v-icon
                :color="
                  $vuetify.breakpoint.xsOnly
                    ? 'white'
                    : computedColor(content.type)
                "
                v-text="computedIcon(content.type)"
              ></v-icon>
            </v-list-item-icon>

            <v-list-item-content style="font:Roboto Condensed !important;">
              {{ ($vuetify.breakpoint.xs&&content.type=='quiz')?("[Quiz] " + content.title):content.title }}
              <v-list-item-subtitle v-if="index == selectedContent - 1">
                <v-chip color="primary" x-small outlined>Now Playing</v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append v-if="!$route.params.standalone">
        <div
          class="pa-1"
          :key="button.title"
          v-for="button in knowledge_base.header_buttons"
        >
          <v-btn block @click="buttonInfo(button)" v-if="button.show">
            {{ button.label }}
          </v-btn>
        </div>
        <!--
        <hr>
        <div
          class="text-center" style="color:#fff">
          <v-img
          :src="require('../assets/fyiio-logo.svg')"
          class="my-3"
          contain
          height="20"
          style="float: left"
        />Powered by fyiio
        </div>
        -->
      </template>
    </v-navigation-drawer>
    <iframe
      :src="tutorialViewer()"
      width="100%"
      height="800"
      frameborder="0"
      allowfullscreen="allowfullscreen"
    ></iframe>
    
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-toolbar color="primary" dark
          >Right-click the qr-code and choose 'Save As...'</v-toolbar
        >
        <v-card-text class="center">
          <br />

          <p class="center" style="display:none">
            <vue-qrcode v-bind:value="qrValue" />
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { ApolloClient, InMemoryCache } from "@apollo/client/core";
import { gql } from "@apollo/client/core";
import kbMixin from "./KnowledgeBaseMixin.js";
import VueQrcode from "vue-qrcode";
import config from "../config";
export default {
  mounted() {
    (this.cdn = `${process.env.VUE_APP_KB_CDN}`),
      (this.client = new ApolloClient({
        uri: `${process.env.VUE_APP_GRAPHQL_HTTP}`,
        cache: new InMemoryCache(),
      }));
    if (this.$route.params.kb_id == "xk") {
      console.log("No kb supplied, getting kb logo");
      
    } else {
      this.getKnowledgeBase(this.$route.params.kb_id);
    }

    this.getCategory(this.$route.params.category_id);
  },
  components: { VueQrcode },
  mixins: [kbMixin],
  data: () => ({
    swipeDirection: 'None',
    aspect_ratio: 1.0,
    theme: false,
    idToken: "",
    dialog: false,
    placeholder_img: "placeholder.jpg",
    img_hold: "",
    organization_id: "",
    cdn: "",
    client: {},
    category: {},
    knowledge_base: {},
    selectedContent: {},
    contentMap: {},
    cards: ["Today", "Yesterday"],
    drawer: false,
    navDrawerPinned: false,
    links: [
      ["mdi-inbox-arrow-down", "Inbox"],
      ["mdi-send", "Send"],
      ["mdi-delete", "Trash"],
      ["mdi-alert-octagon", "Spam"],
    ],
    qrValue: window.location.href,
  }),
  filters: {
        truncate: function (text, length, suffix) {
          if(text!=undefined){
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
          }
        },
  },
  watch: {
    organization_id(val){
      let self=this;
      if (self.$route.params.kb_id == "xk") {
        self.getKbByOrganizationId(val)
      }
    },
    selectedContent(val) {
      console.log(val);
    },
  },
  computed: {
    imgr: function() {
      if (this.img_hold == "") {
        return ''
        //return "@/assets/logo.png"
        //return `${this.cdn}${this.placeholder_img}`;
      } else {
        let url = `${this.cdn}${config.RETRIEVE_FILEPATH_CDN}/${this.organization_id}/${this.img_hold}`;
        this.getImageMeta(url);
        return url;
      }
    },
  },
  methods: {
    swipe (direction) {
      this.swipeDirection = direction
        if(direction=='Left'){
          this.navDrawerPinned=false
        }
        if(direction=='Right'){
          this.navDrawerPinned=true;
        }
        
    },
    buttonInfo: function(button) {
      window.open(button.link, "_blank");
    },
    computedColor(type) {
      if (type == "tutorial") {
        return "transparent";
      } else if (type == "quiz") {
        return "white";
      } else {
        return "transparent";
      }
    },
    getImageMeta(url) {
      var img = new Image();
      let self = this;
      img.addEventListener("load", function() {
        console.log(this.naturalWidth + " " + this.naturalHeight);
        if (this.naturalWidth > this.naturalHeight) {
          console.log("returning: ", 16 / 9);
          self.aspect_ratio = 16 / 9;
        } else {
          console.log("returing: ", 1);
          self.aspect_ratio = 1;
        }
        self.$forceUpdate();
      });
      img.src = url;
    },
    closeThisWindr() {
      window.close();
    },
    tutorialViewer() {
      let holdType = this.selectedContent.type;
      console.log("holdType is", holdType);
      if (holdType == "tutorial") {
        return `//${window.location.host}/s/${this.selectedContent.id}`;
      } else if (holdType == "quiz") {
        console.log(`/q/t/${this.selectedContent.id}`);
        return `//${window.location.host}/q/t/${this.selectedContent.id}`;
      } else {
        console.log("holdType is Undefined");
        return `//${window.location.host}/kbs/selector`;
      }
      //return `${process.env.VUE_APP_DASHBOARD_TUTORIAL_VIEWER}${this.selectedContent.id}`
    },
    bubbaurl() {
      let bubbaurl = `https://${window.location.host}/v/${this.selectedContent.id}`;
      console.log(bubbaurl);
      return bubbaurl;
    },
    loadContent(content_id) {
      console.log(content_id);
      this.category.content.forEach((content) => {
        if (content.id == content_id) {
          this.selectedContent = content;
        }
      });
    },
    getKbByOrganizationId(){
      let self=this;
      self.client
        .query({
          query: gql`
            query GetKnowledgeBase($organization_id: uuid!) {
              knowledge_base(where: {organization_id: {_eq: $organization_id}}) {
                id
                logo
              }
            }
          `,
          variables: {
            organization_id: self.organization_id,
          },
        })
        .then((result) => {
          console.log("kb:", result.data);
          let knowledge_bases = result.data.knowledge_base;
          if(knowledge_bases && knowledge_bases.length>0){
            let knowledge_base=knowledge_bases[0]
            this.theme = knowledge_base.dark_theme;
            if (knowledge_base.logo && knowledge_base.logo != "") {
              this.img_hold = knowledge_base.logo;
            }
          }
        });

    },
    getKnowledgeBase(kb_id) {
      if (kb_id == "xk") {
        return;
      }
      this.client
        .query({
          query: gql`
            query GetKnowledgeBase($id: uuid!) {
              knowledge_base_by_pk(id: $id) {
                id
                title
                description
                organization_id
                logo
                dark_theme
                header_buttons
              }
            }
          `,
          headers: {
            // authorization: `Bearer ${this.id_token}`
          },
          variables: {
            id: kb_id,
          },
        })
        .then((result) => {
          console.log("kb:", result.data);
          this.knowledge_base = result.data.knowledge_base_by_pk;
          this.organization_id = this.knowledge_base["organization_id"];
          this.theme = this.knowledge_base.dark_theme;
          if (this.knowledge_base.logo && this.knowledge_base.logo != "") {
            this.img_hold = this.knowledge_base.logo;
          }
        });
    },
    getCategory(category_id) {
      console.log("Category_id", category_id);
      this.client
        .query({
          query: gql`
            query GetCategory($id: uuid!) {
              category_by_pk(id: $id) {
                id
                title
                description
                created_at
                content
                organization_id
              }
            }
          `,
          headers: {
            // authorization: `Bearer ${this.id_token}`
          },
          variables: {
            id: category_id,
          },
        })
        .then((result) => {
          console.log("categories:", result.data);
          this.category = result.data.category_by_pk;
          this.organization_id=this.category.organization_id
          //create a map for content playback control
          this.contentMap = new Map(
            this.category.content.map((obj) => [obj.id, obj])
          );
          console.log("contentMap:", this.contentMap);
          this.loadContent(this.$route.params.content_id);
        });
    },
  },
};
</script>
<style scoped>
.bg-active {
  background-color: dark-lighten-1;
  color : white !important;
}
hr { display: block; height: 1px;
    border: 0; border-top: 1px solid gray;
    margin: 0em 0; padding: 0; }
</style>
